import authActions from "../actions/auth";
import get from "lodash/get";

const initialState = {
	user: null,
	isFetched: false,
	isAuthenticated: false,
	token: null,
	default_currency_code: "",
	system_currency_codes: "",
	organizations: [],
	selected_organization: null,
	has_main_organization: false,
	is_main_organization: false,
	is_filial_organization: false,
	activeOrganization: null,
	maintenance_mode: false
};

export default (state = initialState, action) => {
	switch (action.type) {
		case authActions.SET_ACTIVE_ORGANIZATION.REQUEST:
			return {
				...state,
				activeOrganization: get(action, "payload.activeOrganization")
			};

		case authActions.SetMaintenanceMode.REQUEST: {
			const maintenance_mode = !!action.payload;
			if (state.maintenance_mode === maintenance_mode) return state;
			return {
				...state,
				maintenance_mode
			};
		}

		case authActions.GetMe.REQUEST:
			return {
				...state,
				isFetched: false
			};

		case authActions.SetToken.REQUEST:
			return {
				...state,
				token: action.payload
			};

		case authActions.GetMe.SUCCESS:
			const organizations = get(action.payload, "organizations", []);
			const selected_organization = get(action.payload, "organization", null);

			const hasMain = organizations.find(o => o.is_main === 1);
			const isMain = get(selected_organization, "is_main") === 1;

			return {
				...state,
				isFetched: true,
				isAuthenticated: true,
				user: action.payload,
				organizations: organizations,
				selected_organization: selected_organization,
				system_currency_codes: get(
					selected_organization,
					"setting.system_currency_codes"
				),
				default_currency_code: get(
					selected_organization,
					"setting.default_currency_code"
				),
				has_main_organization: !!hasMain,
				is_main_organization: isMain,
				is_filial_organization: get(selected_organization, "is_main") === 2
			};

		case authActions.Logout.REQUEST:
		case authActions.Logout.FAILURE:
		case authActions.GetMe.FAILURE:
			return {
				...state,
				isFetched: true,
				isAuthenticated: false,
				token: "",
				user: null
			};

		default:
			return state;
	}
};
